import { ConjugationObject } from '../../interfaces/word-object/cojugation-object/ConjugationObject';

 export class Conjunction {
    public verb: string;
    public infinitive: string;
    public form: string;
    public person: string;
    constructor(conjunctionObject: ConjugationObject){
        this.verb = conjunctionObject.verb;
        this.infinitive = conjunctionObject.infinitive;
        this.person = conjunctionObject.person;
        this.form = conjunctionObject.form;
    }
    isPresent(){
        return this.form == "present";
    }
    isPlusPerfect(){
        return this.form == "plustPerfect";
    }
    isConditional(){
        return this.form == "conditional";
    }
  isPerfect(){
       return this.form == "perfect";
  }
  isPast(){
       return this.form == "past";
  }
  isFuture(){
       return this.form == "future";
  }
  isImprative(){
       return this.form == "imperative";
  }
  
}